import { urlUtil } from '@cmg/common';

import { getAppSettings } from '../config/appSettings';

const ENTERPRISE_PRIVACY_POLICY_URL = 'https://cmgx.io/enterprise-privacy-policy/';

/**
 * Instead of hard coding external URLs that our app links to, we define them in
 * a common location.
 */
const externalRouteFactory = {
  myProfile: {
    getUrlPath: () => {
      const appSettings = getAppSettings();
      const accountSubdomain = urlUtil.getAccountSubdomain(window.location);
      const url = urlUtil.addSubdomainToUrl(appSettings.env.identitySpaBaseUrl, accountSubdomain);
      return `${url}/profile`;
    },
  },
  privacyPolicy: {
    getUrlPath: () => {
      return ENTERPRISE_PRIVACY_POLICY_URL;
    },
  },
  knowledgeBase: {
    getUrlPath: path => {
      const appSettings = getAppSettings();
      const accountSubdomain = urlUtil.getAccountSubdomain(window.location);
      const url = urlUtil.addSubdomainToUrl(
        appSettings.env.identityServiceBaseUrl,
        accountSubdomain
      );
      return `${url}document360?RedirectPath=${path}`;
    },
  },
};

export default externalRouteFactory;
